import { classNames } from '@fullstory/util/fmt';
import React from 'react';
import { Tooltip } from '../../components/Tooltip';
import css from './index.module.scss';

export interface InfoTipProps {
  /** Tippy can be shown as a simple "i" (Text), or a circle icon (Fill) */
  variant?: 'primary' | 'secondary' | 'minimal';
  color?: 'gray' | 'pink' | 'blue';
  tooltipProps: Omit<React.ComponentProps<typeof Tooltip>, 'children' | 'compact'>;
}

/**
 * @deprecated
 * This component is deprecated in favor of using `Tooltip` and `Icon` directly.
 */
export const InfoTip: React.FunctionComponent<InfoTipProps> = ({
  color = 'gray',
  variant = 'primary',
  tooltipProps,
}: InfoTipProps) => (
  <div data-component="InfoTip" className={css.infoTipComponent}>
    <Tooltip {...tooltipProps}>
      {/* eslint-disable-next-line @fullstory/no-rawtext-in-jsx-element-return */}
      <span className={classNames(css.infoTipBtn, css[variant], css[color])}>i</span>
    </Tooltip>
  </div>
);
